<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1">1. Becoming Florence</a></p>
<p class="toc"><a href="#/Chapter2">2. Timeless Crossroads</a></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. The Trickster Near Francis Marion Road</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. A Coonskin Cap</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Welcome to Red Doe Plantation</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. The Voodoo Woman of Firetower Road</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. A Dedicated Worker</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">8. The Watchers at the Corner of Gaillard Street</span></p>
<p class="toc"><span href="#/Chapter9" title="Link target outside of Sample">9. Burned</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">10. Lost</span></p>
<p class="toc"><span href="#/Chapter11" title="Link target outside of Sample">11. When the Piano Plays</span></p>
<p class="toc"><span href="#/Chapter12" title="Link target outside of Sample">12. Foster Care and a Scowling Stare</span></p>
<p class="toc"><span href="#/Chapter13" title="Link target outside of Sample">13. What a Price to Pay</span></p>
<p class="toc"><span href="#/Chapter14" title="Link target outside of Sample">14. Shock and Sorrow</span></p>
<p class="toc"><span href="#/Chapter15" title="Link target outside of Sample">15. In Murder</span></p>
<p class="toc"><span href="#/Chapter16" title="Link target outside of Sample">16. Cat’s Corner</span></p>
<p class="toc"><span href="#/Chapter17" title="Link target outside of Sample">17. Mandarine Waters</span></p>
<p class="toc"><span href="#/Chapter18" title="Link target outside of Sample">18. Calling from the Other Side</span></p>
<p class="toc"><span href="#/Chapter19" title="Link target outside of Sample">19. Like a Bird</span></p>
<p class="toc"><span href="#/Chapter20" title="Link target outside of Sample">20. Test the Spirits</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?95bc5722